// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"app-landing-page_productcontent__ATtaD"};